import React from 'react';

const useSelectValue = (initialValues = []) => {
  const [selected, setSelected] = React.useState(initialValues);
  const handleSelectItem = (value) => {
    const currentIndex = selected.indexOf(value);
    const newChecked = [...selected];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setSelected(newChecked);
  };

  const isChecked = (value) => {
    return selected.indexOf(value) > -1;
  };

  return [selected, setSelected, isChecked, handleSelectItem];
};

export default useSelectValue;
